<jhi-bary-card class="pricing-card h-100 w-100">
  <div header class="header p-3">
    <h5 class="font-weight-bold mt-3">{{ offerEstimation.name }}</h5>
    <h3 *ngIf="offerEstimation.price" class="mb-0 mt-n2 font-weight-bold">
      {{ offerEstimation.price | currency: 'EUR' }}
      {{ 'SUFFIX.PRE_TAXES' | translate }}
    </h3>
  </div>
  <div body class="d-flex flex-column justify-content-between">
    <div>
      <p class="description text-black-50">{{ offerEstimation.description }}</p>
      <p class="calendar" *ngIf="hasFlexibleConfig">
        <span class="d-inline-block">
          <i class="far fa-calendar-days d-inline-block mr-2"></i>
          <ng-container *ngIf="offerEstimation.flexibilityDeadline || offerEstimation.flexibilityDeadline === 0; else fixDeadline">
            {{ 'PRICING_PACK.BODY.FLEXIBLE_DEADLINE' | translate: { days: offerEstimation.flexibilityDeadline } }}
          </ng-container>
          <ng-template #fixDeadline>
            {{ 'PRICING_PACK.BODY.FIXED_DEADLINE' | translate }}
          </ng-template>
        </span>
      </p>
      <ul class="text-left list-unstyled">
        <li *ngFor="let attribute of offerEstimation.items" class="ml-n1">
          <ng-container *ngIf="attribute.icon === 'circle-check'; else XMark">
            <jhi-bary-icon
              *ngIf="attribute.icon"
              [icon]="attribute.icon"
              [faDirective]="FaDirectiveEnum.FAS"
              [class]="'fas-fw text-center w-30 ' + 'text-' + attribute.iconColor"
            ></jhi-bary-icon>
          </ng-container>
          <ng-template #XMark>
            <jhi-bary-icon
              *ngIf="attribute.icon"
              [icon]="attribute.icon"
              [faDirective]="FaDirectiveEnum.FAR"
              [class]="'far-fw text-center w-30 ' + 'text-' + attribute.iconColor"
            ></jhi-bary-icon>
          </ng-template>
          <span>{{ attribute.label }}</span>
        </li>
      </ul>
    </div>
    <div class="mt-2">
      <jhi-bary-button
        class="btn w-100"
        (clickEvent)="handleEstimate()"
        [disabled]="isSelectedOffer"
        [color]="!isSelectedOffer ? 'dark' : 'grey'"
        [label]="(!isSelectedOffer ? selectButtonLabel() : 'BARY_LIGHT_ESTIMATE.BTN.ACTUAL_OFFER') | translate"
        data-id-cypress="btn-choose-offer"
      ></jhi-bary-button>
    </div>
  </div>
  <div footer *ngIf="offerEstimation.carbonFootprint || true" class="footer p-3">
    <i class="fas fa-leaf fas-fw text-black mr-1"></i>
    <span (click)="modal.show()">{{
      'PRICING_PACK.FOOTER.ESTIMATED_CARBON_FOOTPRINT' | translate: { carbonFootprint: offerEstimation.carbonFootprint || 12.5 | number: '1.0-3' }
    }}</span>
  </div>
</jhi-bary-card>
<div mdbModal #modal="mdbModal" class="carbon-footprint-modal modal fade" id="carbonFootprintDetailed" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title w-100 font-weight-bold" jhiTranslate="PRICING_PACK.CARBON_FOOTPRINT_MODAL.HEADER"></h4>
        <i aria-label="Close" (click)="modal.hide()" class="close pull-right align-middle fas fa-times"> </i>
      </div>
      <div class="modal-body d-flex flex-column justify-content-between">
        <p class="lead" jhiTranslate="PRICING_PACK.CARBON_FOOTPRINT_MODAL.CONTENT.PARAGRAPH_1"></p>
        <p class="lead" jhiTranslate="PRICING_PACK.CARBON_FOOTPRINT_MODAL.CONTENT.PARAGRAPH_2"></p>
        <p class="lead m-0" jhiTranslate="PRICING_PACK.CARBON_FOOTPRINT_MODAL.CONTENT.PARAGRAPH_3"></p>
      </div>
    </div>
  </div>
</div>
